import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-candidate-card-actions-modal',
  templateUrl: './candidate-card-actions-modal.component.html'
})
export class CandidateCardActionsModalComponent implements OnInit {

  modalData: any;
  public onClose: Subject<any>;

  constructor(
    private bsModalRef: BsModalRef,
    public bsModalService: BsModalService
  ) {
    this.onClose = new Subject();
    if (this.bsModalService.config.initialState) {
      this.modalData = this.bsModalService.config.initialState;
    }
  }

  ngOnInit() {
  }

  closeModal() {
    this.onClose.next(null);
    this.bsModalRef.hide();
  }

  saveCallback() {
    this.onClose.next(true);
    // 'updateContact' keeps the modal open after saving so the recruiter can continue editing.
    if (this.modalData.type !== 'updateContact') {
      this.bsModalRef.hide();
    }
  }

  deleteCallback() {
    if (this.modalData.deleteCandidateCallback) {
      this.modalData.deleteCandidateCallback();
    }
    this.closeModal();
  }

}
